import React from 'react';
import { Tag, TagProps } from 'antd';
import { PresetColorType, PresetStatusColorType } from 'antd/lib/_util/colors';
import { LiteralUnion } from 'app/definitions/types';
import classes from './Status.module.scss';
import cn from 'classnames';
import { MapColorWithAntd } from './constants';

type StatusType = 'text' | 'tag';

type StatusProps = Partial<TagProps> & {
  type: StatusType;
  value?: string;
  children?: React.ReactNode;
  color?: LiteralUnion<PresetColorType | PresetStatusColorType, string>;
  className?: string;
  borderless?: boolean;
};

const Status: React.FC<StatusProps> = (props) => {
  const {
    type,
    value,
    children,
    className,
    borderless,
    color = 'default',
    ...tagProps
  } = props;

  const antdClassName = MapColorWithAntd.get(color as string);

  const styles = React.useMemo(() => {
    if (type === 'text' && !antdClassName) {
      return {
        color: color as string
      };
    }
    return {};
  }, [antdClassName, color, type]);

  return (
    <Tag
      style={styles}
      className={cn(
        classes['status'],
        {
          [classes['status--ghost']]: type === 'text',
          [classes['status--borderless']]: borderless
        },
        antdClassName,
        className
      )}
      color={color as string}
      {...tagProps}
    >
      {value || children}
    </Tag>
  );
};

export default Status;
